/* 2026-10-20: Boost が描く商品カード（コレクション・検索）にも、TOP と同じ容量・発送日の札を出す。
   Boost のカードからは商品メタフィールド（custom.ship_start）が見えないので、各カードの商品ページを
   ?view=chip（templates/product.chip.liquid＝snippets/re-vol-badge.liquid）で読み、返った札を商品名の上に差し込む。
   読んだ結果はブラウザに30分だけ覚える（日付が変わったら捨てる）。失敗した読み込みは覚えない。
   Boost が描き直したら（ページ送り・絞り込み・並び替え・カードの使い回し）付け直す。
   撤去：このファイル・templates/product.chip.liquid・layout/theme.liquid の読み込み行を消す。 */
(function () {
  var TTL = 30 * 60 * 1000;
  var today = new Date(); today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  var CACHE_KEY = 'reBoostChips:v2:' + today;
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}'); } catch (e) {}
  var pending = {};

  function save() { try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {} }

  function handleOf(item) {
    var a = item.querySelector('a[href*="/products/"]');
    if (!a) return '';
    var m = (a.getAttribute('href') || '').split('?')[0].match(/\/products\/([^\/#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  // 札の部品だけが返ったときに true。テンプレートが無いと商品ページ全体が返るので、それは使わない
  function valid(html) { return html === '' || (html.indexOf('<div class="re-vol-row"') === 0 && html.length < 2000); }

  function load(handle) {
    var c = cache[handle];
    if (c && Date.now() - c.t < TTL) return Promise.resolve(c.h);
    if (pending[handle]) return pending[handle];
    pending[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=chip', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        html = (html || '').trim();
        delete pending[handle];
        if (!valid(html)) return '';
        cache[handle] = { h: html, t: Date.now() }; save();
        return html;
      })
      .catch(function () { delete pending[handle]; return ''; });
    return pending[handle];
  }

  function apply(item) {
    var title = item.querySelector('.boost-sd__product-title');
    if (!title) return;
    var handle = handleOf(item);
    var box = item.querySelector('.re-boost-chips');
    if (box && box.getAttribute('data-handle') === handle && box.nextElementSibling === title) return;
    if (!handle) { if (box) box.remove(); return; }
    if (!box || box.nextElementSibling !== title) {
      if (box) box.remove();
      box = document.createElement('div'); box.className = 're-boost-chips';
      title.parentNode.insertBefore(box, title);
    }
    box.setAttribute('data-handle', handle);
    box.innerHTML = '';
    load(handle).then(function (html) {
      if (box.getAttribute('data-handle') === handle) box.innerHTML = html;
    });
  }

  function scan() { document.querySelectorAll('.boost-sd__product-item').forEach(apply); }

  var timer = null;
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      var el = t.nodeType === 1 ? t : t.parentElement;
      if (!(el && el.closest && el.closest('.re-boost-chips'))) { clearTimeout(timer); timer = setTimeout(scan, 80); return; }
    }
  }).observe(document, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['href'] });
  scan();
})();
